import { css } from "../../sitches.config";

export const styles = {
  value: css({
    color: "$emeraldish"
  })
};
